@use 'sass:math';
@use '../../../scss/utility';

:host {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
}

@mixin overwrite-grid-col-width-for-mq($mq) {
  @for $i from 1 through utility.$wb-grid-column-amount {
    :host([#{$mq}='#{$i}']) {
      width: calc(var(--wb-grid-column-width) * #{$i} + var(--wb-grid-gutter-width) * #{$i - 1});
    }
  }
}

@each $mq in map-keys(utility.$wb-breakpoints) {
  @if ($mq == mq1) {
    @include overwrite-grid-col-width-for-mq($mq);
  } @else {
    @include utility.breakpoint-from($mq) {
      @include overwrite-grid-col-width-for-mq($mq);
    }
  }
}
